import { Link } from 'react-router-dom'

const RecentTractsTable = ({
    tracts,
    recentTracts,
    addTractInFavorite,
    deleteTractIsFavorite,
    setEditTract,
    setDeleteTract,
    showHideAddTract,
    showHideDelete,
}) => {
    
    return (
        
        <div className="mb-0 RecentTractsTable ">
            
            <div className="p-0 px-3 card-body">
                
                {recentTracts?.map(recentTract => (
                    
                    <div
                        key={`recent-tracts-${recentTract.tractId}`}
                        className="row"
                        style={{
                            border: '3px solid #243a59',
                            borderRadius: '8px',
                            backgroundColor: '#152e4d',
                            minHeight: '55px',
                        }}>
                        
                        <div className="mt-3 col-2" style={{ maxWidth: '120px' }}>
                            <Link to={`/tract/${recentTract.tractId}`}>
                                {recentTract.tractName}
                            </Link>
                        </div>
                        
                        <div className="mt-3 text-center col-3">
                            {recentTract.grossAcreage} Acres
                        </div>
                        
                        <div className="mt-3 text-center col-2">
                            {recentTract.assignedTo}
                        </div>
                        
                        <div className="mt-3 text-center col-3">
                            {recentTract.status}
                        </div>
                        
                        <div className="mt-3 text-right col-2">
                            <span
                                className="fe fe-star icon-mid"
                                id={recentTract.tractName}
                                onClick={() => {
                                    // @todo wtf is this
                                    // eslint-disable-next-line no-restricted-globals
                                    let starStyle = document.getElementById(
                                        recentTract.tractName,
                                    )
                                    
                                    if (
                                        starStyle.className === 'fe fe-star-fill icon-mid'
                                    ) {
                                        deleteTractIsFavorite(recentTract.tractId)
                                        starStyle.className = 'fe fe-star icon-mid'
                                    } else {
                                        let resTract = tracts?.filter(
                                            tract => tract.id === recentTract.tractId,
                                        )
                                        
                                        addTractInFavorite(resTract[0].id)
                                        starStyle.className = 'fe fe-star-fill icon-mid'
                                    }
                                }} />
                            
                            <i
                                className="ml-3 mr-3 fe fe-edit-2 pointer-cursor"
                                onClick={() => {
                                    let tract = tracts?.filter(
                                        c => c.id === recentTract.tractId,
                                    )
                                    
                                    setEditTract(tract[0])
                                    showHideAddTract(true)
                                }} />
                            
                            <i
                                className="fe fe-trash pointer-cursor"
                                onClick={() => {
                                    let tract = tracts?.filter(
                                        c => c.id === recentTract.tractId,
                                    )
                                    
                                    setDeleteTract(tract[0])
                                    showHideDelete(true)
                                }} />
                        
                        </div>
                    
                    </div>
                    
                ))}
            
            </div>
        
        </div>
        
    )
    
}

export default RecentTractsTable
